import { render, staticRenderFns } from "./cpuOptions.vue?vue&type=template&id=650915c6&scoped=true&"
import script from "./cpuOptions.vue?vue&type=script&lang=js&"
export * from "./cpuOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650915c6",
  null
  
)

export default component.exports